import { LengthTokenValue } from 'designSystem/types';
import * as S from './styles';

interface LengthTokenPreviewProps {
	value: LengthTokenValue;
}

export const LengthTokenPreview = ({ value }: LengthTokenPreviewProps) => {
	const displayValue = value.px !== undefined ? `${value.px}px` : value.original;
	return (
		<S.PreviewContainer>
			<S.LengthBar width={value.px || value.numericValue * 16} />
			<S.ValueText>{displayValue}</S.ValueText>
		</S.PreviewContainer>
	);
};
